import { combineReducers } from "@reduxjs/toolkit"
import { textStylesReducer } from "@store/reducers/text-style/reducer"
import { templatesReducer } from "@store/reducers/templates/reducer"
import { wordArtReducer } from "@store/reducers/wordarts/reducer"
import { initReducer } from "./reducers/init/reducer"
import { paperReducer } from "./reducers/paper/reducer"

export const staticReducers ={
  textStyles: textStylesReducer,
  templates: templatesReducer,
  wordArt: wordArtReducer,
  init: initReducer,
  paper: paperReducer
}

export type RootState = any;// ReturnType<typeof staticReducers>


